<template>
  <div class="mt-5">
    <data-table
      title="Companies Associated To this Offer"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
      ><template slot="item.offerable" slot-scope="{ item }">
        <div v-if="item.owner_type == 'companies'">{{ item.offerable.name }} (company)</div>
        <div v-else>{{ item.offerable.full_name }} (individual user)</div>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <v-btn small icon @click.stop="deleteOffer(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </data-table>
  </div>
</template>
<script>
export default {
  props: {
    offer: {
      required: true,
    },
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      editingOffer: null,
      //   url: `api/v1/offers/${this.offer.id}/transactionOffers`,
      headers: this.pairTableLabelWithValue({
        ID: "id",
        Name: "offerable",
        Actions: "actions",
      }),
    };
  },
  created() {},

  computed: {
    url() {
      return `api/v1/userOffer/${this.offer.id}`;
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    offerAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    offerUpdated({ message }) {
      this.editingOffer = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateOffer(offer) {
      this.editingOffer = Object.assign({}, offer);
      this.isEditing = true;
    },
    deleteOffer(offer) {
      const id = offer.id;
      Notify.confirm(`Do you want to detach this Offer?`).then(() => {
        this.$http
          .delete(`/api/v1/userOffer/${id}/detach`)
          .then((result) => {
            Notify.success(result.message);
            this.$refs.table.fetchData();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
  },
};
</script>
